import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageCheckout = lazy(() => import("./layout/index"));

export const routerPageStoreCheckout: RouterItemType = {
  path: "/store/checkout",
  authorize: true,
  element: <LayoutPageCheckout />,
};
